import { render, staticRenderFns } from "./confirm-box.vue?vue&type=template&id=0790bb1a&"
import script from "./confirm-box.vue?vue&type=script&lang=js&"
export * from "./confirm-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports